export default "<c-corporate-footer class=\"fixed-footer\"></c-corporate-footer>\r\n";